const initialState={
    company:"",
    companyEntry:{ name: "",
    gst_number: "",
    panno: "",
    principal_place_business: "",
    Company_status: "",
    tan_no: "",
    floorno: "",
    building_name: "",
    street: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    contactno: "",
    mobileno: "",
    status: "",
    email_id: "",
    mail_server: "",
    mail_port: "",
    mail_id: "",
    mail_password: "",
    mail_connection: "",
    department: "",
    severity_wise: "",
    calld_id: "",
    no_of_day_new_ticket: 7,
    authorised: "",
    registration: "",
    cc_mail: "",
    escalation_status: "",
    escalation_mail: "",
    escalation_cc: "",
}
};

export const CompanyReducers=(state=initialState,action)=>{
    switch(action.type){
        case "COMPANY":
            return {...state,company:action.payload};
        case "COMPANYENTRY":
            return {companyEntry:action.payload}    
         default:
            return state;   
    };
}; 